// extracted by mini-css-extract-plugin
export default {"styledButton":"Button_styledButton__bzPV4"};